import BaseService from "../../base/base_service";
import _ from '../../utils/underscore';
import Device from '../../utils/device/device';
import DOM from '../../utils/dom';

interface IParams {
  domains: string[];
  enable: boolean;
}

export default class DomainDetectionService extends BaseService{
  static CLASS="DomainDetectionService";

  _params: IParams;

  init(params: IParams){
    this._params = params;
  }

  onInitializationCompleted(): Promise<void> {
    if(!_.isNullOrUndefined(this._params)){
      this._verifyDomain();
    }

    return Promise.resolve();
  }

  private _verifyDomain(){

    if(_.isNullOrUndefined(this._params.domains) ||
          (!_.isNullOrUndefined(this._params.domains) && this._params.domains.length === 0) ||
          Device.hybrid.isHybrid ||
          this.serviceFactory.windowService().getDomain() === 'localhost' ||
          (!_.isNullOrUndefined(this._params.enable) && _.toBoolean(this._params.enable) === false)) {
      return;
    }

    if (!this._isDomainApproved()) {
      this._cleanDom();
      this._sendElasticEvent();
    }
  }

  private _isDomainApproved(): boolean {
    const currentDomain = this.serviceFactory.windowService().getHost();
    const verifyCurrentDomain = domain => currentDomain.endsWith(domain);
    return this._params.domains.some(verifyCurrentDomain);
  }

  private _cleanDom(){
    DOM.getBody().innerHTML = "";
    this.logger.info("Not approved domain! Content removed.");
  }

  private _sendElasticEvent(){
    const data = {
      CGPEventCategory: 'DOMAIN_DETECTION',
      CGPEventAction: "BLOCKED_DOMAIN",
      CGPEventLabel: this.serviceFactory.windowService().getHref()
    };
    this.serviceFactory.structuredLoggingService().getLogger(data).info();
  }
}